// @ts-nocheck
import React, {FC, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Row,
  Col,
  Button, Label,
} from 'reactstrap';
import ListCountries from '../../Lists/ListCountries';
import {useNavigate} from 'react-router-dom';
import {editCustomer} from '../../../store/customer/actions';
import {createLoadingSelector} from '../../../selectors/loading';
import {EDIT_CUSTOMER} from '../../../store/customer/actionTypes';
import {createErrorSelector} from '../../../selectors/error';
import {FormProvider, useForm} from 'react-hook-form';
import FormField from '../../Common/FormField';
import {SweetAlert} from '../../Common/SweetAlert';

interface CustomerFormProps {
  customer: FullCustomer,
}

/* eslint-disable camelcase */
const CustomerForm: FC<CustomerFormProps> = ({customer}) => {
  const dispatch = useDispatch();

  const loadingSelector = useSelector(
      createLoadingSelector([EDIT_CUSTOMER]),
  );
  const errorSelector = useSelector(createErrorSelector([EDIT_CUSTOMER]));

  const [errorMsg, setErrorMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();

  const form = useForm({
    defaultValues: customer,
  });
  const {
    handleSubmit,
  } = form;

  useEffect(() => {
    if (submitted) {
      setSuccessMsg(!loadingSelector && errorSelector.length === 0);
      setErrorMsg(!loadingSelector && errorSelector.length > 0);
    }
  }, [loadingSelector, errorSelector, submitted]);

  function handleValidSubmit(values) {
    setSubmitted(true);
    if (values.id) {
      const editedCustomer: EditAPICustomer = {
        id: values.id,
        contact_name: values.contact_name,
        additional_address: values.additional_address,
        street: values.street,
        street_no: values.street_no,
        zip_code: values.zip_code,
        city: values.city,
        country: values.country,
        phone: values.phone,
        email: values.email,
        www: values.www,
      };
      dispatch(editCustomer(editedCustomer));
    }
  }

  return (
    <FormProvider {...form}>
      <form
        className="form-horizontal"
        onSubmit={handleSubmit(handleValidSubmit)}
      >
        {errorMsg ?
          <SweetAlert
            title="Error!"
            danger
            showConfirm={true}
            showCancel={false}
            confirmBtnBsStyle="danger"
            // closeOnConfirm={true}
            onConfirm={() => {
              setErrorMsg(false);
            }}
          >
            {errorMsg}
          </SweetAlert> : ''
        }
        {successMsg ? <SweetAlert
          title="Good job!"
          success
          showConfirm={true}
          showCancel={false}
          confirmBtnBsStyle="yellow"
          onConfirm={() => {
            navigate('/customers');
          }}
        >
          The customer has been updated!
        </SweetAlert> : null}
        <Row>
          <Col md="6">
            <FormField
              name="name"
              className="form-control"
              placeholder="Company name *"
              label="Company"
              type="text"
              disabled={true}
            />
          </Col>
          <Col md="4">
            <FormField
              name="contact_name"
              className="form-control"
              placeholder="Contact name *"
              label="Contact"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a contact name."
            />
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <FormField
              name="additional_address"
              className="form-control"
              placeholder="Additional Address (optional)"
              label="Additional Address"
              type="text"
              validate={{required: {value: false}}}
              errorMessage="Please provide a valid additional address."
            />
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <FormField
              name="street"
              className="form-control"
              placeholder="Street *"
              label="Street"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid street."
            />
          </Col>
          <Col md="2">
            <FormField
              name="street_no"
              className="form-control"
              placeholder="Street No *"
              label="Street No"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid street no."
            />
          </Col>
          <Col md="2">
            <FormField
              name="zip_code"
              className="form-control"
              placeholder="Zip Code *"
              label="Zip Code"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid zip code."
            />
          </Col>
          <Col md="3">
            <FormField
              name="city"
              className="form-control"
              placeholder="City *"
              label="City"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid city."
            />
          </Col>
          <Col md="3">
            <div className="form-group">
              <Label htmlFor="country" className="col-form-label">Country</Label>
              <ListCountries
                initialSelect={customer.country}
                required={true}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <FormField
              name="phone"
              className="form-control"
              placeholder="Phone *"
              label="Phone"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid phone number."
            />
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <FormField
              name="email"
              className="form-control"
              placeholder="Email Address*"
              label="Email"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid email address."
            />
          </Col>
          <Col md="4">
            <FormField
              name="www"
              className="form-control"
              placeholder="Web Address *"
              label="Web Address"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a web address."
            />
          </Col>
        </Row>
        <Button
          disabled={loadingSelector}
          type="submit"
          color="primary"
        >Save</Button>
      </form>
    </FormProvider>
  );
};
export default CustomerForm;
/* eslint-enable camelcase */
